module.exports = __webpack_public_path__ + "static/media/nasa1.073f50e7.jpg";